export const PromiseStatus = Object.freeze({
  /**  fulfilled*/
  Fulfilled: 'fulfilled',
  /**  rejected*/
  Rejected: 'rejected',
});
